// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperNewsStory-cls1_xtS","cls2":"PaperNewsStory-cls2_-JH PaperNewsStory-cls1_xtS","variant-dense":"PaperNewsStory-variant-dense_C60"};